import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { SnackbarProvider } from 'notistack';
import App from './components/App';
import { BrowserRouter } from 'react-router-dom'
import { createStore } from 'redux'
import reducer from './reducers'
import { Provider } from 'react-redux'
import 'bootstrap/dist/css/bootstrap.min.css';
// import { ProSidebarProvider } from 'react-pro-sidebar';
import './components/pre_login/AppStart_v2_parts/style.css';
import { CacheProvider } from '@emotion/react';
import createCache from '@emotion/cache';
import { ThemeProvider, createTheme } from '@mui/material/styles';

// // Goober関連のインポート
// import { setup } from 'goober';

// Create cache with nonce
const cache = createCache({
  key: 'my-prefix',
  nonce: 'editor_nonce_20240908',
});

// // Goober関連のセットアップ
// setup(React.createElement, undefined, { nonce: 'goober_nonce_20240908' });

// // Gooberのnonce設定
// const gooberStyle = document.createElement('style');
// gooberStyle.setAttribute('nonce', 'goober_nonce_20240908');  // Goober用のnonce設定
// document.head.appendChild(gooberStyle);
// setup(undefined, gooberStyle);  // Gooberのカスタムスタイルシートをセットアップ

const theme = createTheme();

// prepare store
const store = createStore(
  reducer,
)

// <BrowserRouter basename={'/annotation_tool'}>
ReactDOM.render(
  <Provider store={store}>
    <CacheProvider value={cache}>
      <ThemeProvider theme={theme}>
        <BrowserRouter>
          <SnackbarProvider maxSnack={3}>
              <App />
          </SnackbarProvider>
        </BrowserRouter>
      </ThemeProvider>
    </CacheProvider>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
